/**
 * Classe base para a formatação de dados do tipo data.
 * @author: Adalto Junior
 * Date: 11/08/2014
 */

Monet.Format = Monet.Format || {};
Monet.Format.DISTANCE = (function () {
    function DISTANCE(value) {

        Monet.Format.DECIMAL.apply(this, arguments);

        this.value = value;

        this.convertMetersToMiles = function () {

            this.value = new BigInt(this.value) * 0.00062137;

            return this;

        };

        this.convertFeetToMeters = function () {

            this.value = this.value / 3.2808;

            return this;

        };

        this.convertMetersToKilometers = function () {

            this.value = this.value / 1000;

            return this;

        };

        this.convertMilesToMeters = function () {

            this.value = this.value / 0.00062137;

            return this;

        };

        this.convertMetersToFeet = function () {

            this.value = this.value * 3.2808;

            return this;

        };

        this.convertKmToMiles = function () {

            this.value = this.value * 0.62137;

            return this;

        };

        this.convertKmToMeters = function() {
            this.value = new BigInt(this.value) * 1000;

            return this;
        };

        this.convertMilesToKm = function () {

            this.value = this.value / 0.62137;

            return this;

        };

        this.formatWithoutSeparatorThousands = function () {

            var thousandSeparator = Monet.I18n.locale.digitalGrouping;
            if(this.value) {
                this.format();
                this.value = this.value.replace(thousandSeparator, '');
            }

            return this;

        };

        this.toGrid = function () {

            if (!this.value && this.value !== 0) {
                this.value = '';
            } else if (Monet.Session.User.unitSystem === 'METRIC') {

                const maxMeters = 1000; //this represents 1 km
                let unitSystem = Monet.I18n.getResourcesByKey('UnitSystems.Meters.abbreviation');

                if (Math.abs(this.value) > maxMeters) {
                  this.convertMetersToKilometers();
                  unitSystem = Monet.I18n.getResourcesByKey('UnitSystems.Kilometers.abbreviation');
                }

                this.format();
                this.value += ' ' + unitSystem;

            } else if (Monet.Session.User.unitSystem === 'NON_METRIC') {

                const maxFeet = 528; //this represents 0.1 mile
                let unitSystem = Monet.I18n.getResourcesByKey('UnitSystems.Feet.abbreviation');
                this.convertMetersToFeet();

                if (Math.abs(this.value) > maxFeet) {
                  this.convertFeetToMeters();
                  this.convertMetersToMiles();
                  unitSystem = Monet.I18n.getResourcesByKey('UnitSystems.Miles.abbreviation');
                }

                this.format();
                this.value += ' ' + unitSystem;

            }
         
             return this;

        };

    }

    return DISTANCE;

}());
